<template functional>
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="link-icon"
  >
    <rect x="9.29004" width="1" height="8" transform="rotate(45 9.29004 0)" fill="#CCCCCC"/>
    <path d="M6 0V1H9V4H10V0H6Z" fill="#CCCCCC"/>
    <path d="M4 1H0V9.99978H9V6H8V9H1V2H4V1Z" fill="#CCCCCC"/>
  </svg>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component
class LinkIcon extends Vue {}

export default LinkIcon
</script>

<style>
  .link-icon {
    padding-left: 5px;
  }
</style>
